import React from 'react';
import classNames from 'classnames';
import Tooltip from 'react-tooltip';
import { v4 as uuidv4 } from 'uuid';
import './styles.scss';
import ReactTooltip from 'react-tooltip';

const ToolbarButton = React.forwardRef((props, ref) => {
  const classes = classNames({
    'up-toolbar-button': true,
    'up-button-disabled': props.disabled,
    [props.className]: !!props.className
  });

  const tooltipClasses = classNames({
    'up-button-tooltip': true,
    [props.tooltipClassName]: !!props.tooltipClassName
  });

  const uniqueId = uuidv4();

  return (
    <button
      {...props}
      id={props.id}
      aria-label={props['aria-label'] || props.tooltip}
      aria-disabled={props.disabled}
      className={classes}
      disabled={props.disabled}
      onClick={props.action}
      // show and hide ReactTooltip or else Cypress tests will fail
      onFocus={e => ReactTooltip.show(e.target)}
      onBlur={e => ReactTooltip.hide(e.target)}
      data-tip={props.tooltip}
      data-for={uniqueId}
      datatest={props.datatest}
      ref={ref}
      tabIndex={props.tabIndex}
    >
      {props.icon}
      <Tooltip
        className={tooltipClasses}
        effect="solid"
        event="mouseover"
        eventOff="mouseleave"
        id={uniqueId}
        globalEventOff="click"
        offset={props.tooltipOffset}
      />
    </button>
  );
});

export default ToolbarButton;
